/* eslint-disable no-unused-vars */
import React, { useMemo } from "react";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { NUMBER } from "../../../constants/app-constants";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import AutoScroll from "../../shared/auto-scroll";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { SF_CMS_IMAGE_SLUGS } from "../../../constants/sf-landing-constants";

const LendingPartners = ({ images }) => {
    const { tokens } = useTokens();

    const lendingPartnerImages = useMemo(
        () =>
            (images || []).filter(
                (img) =>
            img?.imageSlug?.split("_")?.at(-1) ===
            SF_CMS_IMAGE_SLUGS.LENDING_PARTNER_PREFIX
            ) || [],
        [images]
    );

    return (
        <div styleName={"styles.lendingPartnersContainer"}>
            <div styleName={"styles.container"}>
                <Heading
                    level={NUMBER.TWO}
                    color={tokens.text_default_text_primary}
                    isBold
                >
            Lending Partners
                </Heading>
            </div>
            <div styleName={"styles.carouselContainer"}>
                <AutoScroll speed={NUMBER.THIRTY_TWO} overflow="hidden" gap="32px">
                    {lendingPartnerImages?.map((partner, index) => (
                        <div key={index} styleName={"styles.partnerLogo"}>
                            <div styleName={"styles.partnerLogoContainer"}>
                                <img
                                    src={partner.desktopImage || partner.image}
                                    alt={partner.heading || partner.imageSlug || "partner"}
                                    loading="lazy"
                                    width={160}
                                    height={80}
                                />
                            </div>
                        </div>
                    ))}
                </AutoScroll>
            </div>
        </div>
    );
};

LendingPartners.propTypes = {
    images: PropTypes.array
};

export default LendingPartners;
